import React from 'react';

const ResultadoApmbbPage = () => {
  return (
    // O contêiner usa flexbox para garantir que o iframe ocupe todo o espaço disponível
    <div style={{ width: '100%', height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <iframe
        src="https://resultadoapmbb.web.app/"
        title="Resultado APMBB"
        style={{ flex: 1, border: 'none', width: '100%' }}
        allowFullScreen
      />
    </div>
  );
};

export default ResultadoApmbbPage;